<a *ngIf="selected; else unselectedItem" class="mc-license-nav-list-item-inner mc-plain-link mc-d-flex mc-align-items-center" [routerLink]="['/', license.Id]">
  <ng-container *ngTemplateOutlet="itemContent"></ng-container>
</a>
<ng-template #unselectedItem>
  <button type="button" class="mc-license-nav-list-item-inner mc-d-flex mc-align-items-center" (click)="onClicked()">
    <ng-container *ngTemplateOutlet="itemContent"></ng-container>
  </button>
</ng-template>

<ng-template #itemContent>
  <mc-license-avatar class="mc-flex-shrink-0" [disabled]="true" [license]="license" [showName]="false" [size]="size"></mc-license-avatar>
  <span class="mc-license-nav-list-item-text mc-d-flex mc-flex-column">
    <span class="mc-license-nav-list-item-license-name">{{ license.KeyLabel }}</span>
    <span *ngIf="size === 'normal' || size === 'large'" class="mc-text-link">{{ displayHref }}</span>
  </span>
  <mat-progress-spinner *ngIf="!selected && (loadingState.loading$ | async)" class="mc-license-nav-list-item-loader mc-flex-shrink-0" color="accent-vivid" diameter="22" mode="indeterminate"></mat-progress-spinner>
  <mat-icon *ngIf="!selected && (loadingState.loading$ | async) !== true" class="mc-license-nav-list-item-external-link-icon mc-image-icon mc-flex-shrink-0" fontSet="project-titan" fontIcon="icon-assign-task"></mat-icon>
</ng-template>
